import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'

import { IdentificationsStatusUpdateParamsSchemas } from 'schemas/identificationsSchemas'
import { IdentificationsStatusUpdateParamsTypes } from 'types/identifications'

export const useMemberIdentificationsStatusUpdateForm = ({
  defaultValues,
}: {
  defaultValues: IdentificationsStatusUpdateParamsTypes
}) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
  } = useForm<IdentificationsStatusUpdateParamsTypes>({
    resolver: zodResolver(IdentificationsStatusUpdateParamsSchemas),
    defaultValues,
  })

  return {
    handleSubmit,
    control,
    errors,
    setValue,
    reset,
    watch,
  }
}
